import { onMounted, onUnmounted, ref } from 'vue';
import { AvatarParameters, Role } from '@/types';

export const getAvatar = (user: AvatarParameters | null | undefined): string => {
  if (user?.avatarUrl) {
    return user.avatarUrl;
  }
  if (user?.role === Role.Doctor) {
    return 'https://davinci-public.s3.eu-central-1.amazonaws.com/avatar_doctor.svg';
  } else {
    return 'https://davinci-public.s3.eu-central-1.amazonaws.com/avatar_patient.svg';
  }
};

enum MaxWidth {
  Mobile = 640,
  Tablet = 768,
  Desktop = 1024,
  LargeDesktop = 1280,
  ExtraLargeDesktop = 1536,
}

export enum Device {
  Mobile = 'Mobile',
  Tablet = 'Tablet',
  Desktop = 'Desktop',
}

export const useMatchDevice = () => {
  const mediaQueryMobile = window.matchMedia(`(max-width: ${MaxWidth.Mobile}px)`);
  const mediaQueryTablet = window.matchMedia(`(max-width: ${MaxWidth.Tablet}px)`);
  const mediaQueryDesktop = window.matchMedia(`(max-width: ${MaxWidth.Desktop}px)`);

  const device = ref<Device>(mediaQueryDesktop.matches ? Device.Desktop : mediaQueryTablet.matches ? Device.Tablet : Device.Mobile);

  const onMatchMobileMediaChange = () => {
    device.value = Device.Mobile;
  };

  const onMatchTabletMediaChange = () => {
    device.value = Device.Tablet;
  };

  const onMatchDesktopMediaChange = () => {
    device.value = Device.Desktop;
  };

  onMounted(() => {
    mediaQueryMobile.addEventListener('change', onMatchMobileMediaChange);
    mediaQueryTablet.addEventListener('change', onMatchTabletMediaChange);
    mediaQueryDesktop.addEventListener('change', onMatchDesktopMediaChange);
  });

  onUnmounted(() => {
    mediaQueryMobile.removeEventListener('change', onMatchMobileMediaChange);
    mediaQueryTablet.removeEventListener('change', onMatchTabletMediaChange);
    mediaQueryDesktop.removeEventListener('change', onMatchDesktopMediaChange);
  });

  return device;
};
